/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Reference/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Reference({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/Step/Reference"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let stepsCurrentIndexValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'current_index',
})
let stepItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'index',
})
let aggregateData = fromAggregate.equals(stepsCurrentIndexValueData, stepItemIndexValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}